//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex'
import { Tab, TabItem } from '../Common/Tab'
import { Card, CardItem, SportsTourCard } from '../Common/Card'
import MatchEmpty from '../Common/MatchEmpty.vue'
import FilterOption from '../Common/FilterOption.vue'
import loadmoreView from '../Common/loadmoreView.vue'
import fixSafariOverflowScrolling from '../../utils/safari-fix'

export default {
  name: 'SportsTourList',
  components: {
    Card,
    CardItem,
    SportsTourCard,
    Tab,
    TabItem,
    MatchEmpty,
    FilterOption,
    loadmoreView,
  },
  mounted() {
    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling')
    fixSafariOverflowScrolling(this, 'touch')
    document.getElementById('line1').style.display = 'block'
    document.getElementById('line2').style.display = 'none'
    window.addEventListener('scroll', this.handlescroll, true)
  },
  data() {
    return {
      tourlistdata: [],
      tabitems: [],
      routeType: 1,
      placeholder: '加载中',
      showFilterOption: false,
      optionType: '',
      options: [],
      currentcategoryId: null,
      selected: {
        time: {},
        category: {},
        city: {},
      },
      filter: {
        time: null,
        categoryId: null,
        cityId: null,
      },
      selectedOption: {},
      selectedType: '',
      routeCategories: [],
      allroutes: [],
      showmoreLoading: false,
      canloadmore: false,
      showFilterBar: false,
      width: (window.innerWidth || document.body.clientWidth) - 120 - 20 - 8,
    }
  },
  computed: {
    ...mapState({
      filterInfo: ({ sportsTour }) => sportsTour.filterInfo,
      routeList: ({ sportsTour }) => sportsTour.routes,
    }),
  },
  methods: {
    ...mapActions(['fetchSportsTourRouteList', 'fetchSportsTourFilterInfo']),
    isEmpty(data) {
      this.showmoreLoading = false
      if (data.routes.length === 0) {
        this.canloadmore = false
        this.placeholder = '没有相关数据'
      }
      if (this.tourlistdata === null) {
        this.tourlistdata = []
      }

      for (let i = 0; i < data.routes.length; i += 1) {
        this.tourlistdata.push(data.routes[i])
      }
      this.canloadmore = true
    },
    loadmore(data) {
      this.showmoreLoading = false
      if (data.routes.length === 0) {
        this.canloadmore = false
        this.placeholder = '没有相关数据'
      }

      if (this.tourlistdata === null) {
        this.tourlistdata = []
      }

      for (let i = 0; i < data.routes.length; i += 1) {
        this.tourlistdata.push(data.routes[i])
      }
    },
    roadmore() {
      this.showmoreLoading = true
      this.fetchSportsTourRouteList({
        categoryId: this.currentcategoryId,
        routeType: this.routeType,
        opts: this.filter,
        offset: this.tourlistdata.length,
      }).then((data) => {
        this.loadmore(data)
      })
    },
    handlescroll() {
      const el = document.getElementById('content-wrapper')
      const offsetHeight = el.offsetHeight
      const scrollTop = el.scrollTop
      const scrollHeight = el.scrollHeight
      if ((offsetHeight + scrollTop) - scrollHeight >= -1) {
        if (this.canloadmore) {
          this.roadmore()
        }
      }
    },
    switchTab(categoryId) {
      const replaceQuery = {}
      replaceQuery.routeType = this.routeType
      replaceQuery.categoryId = categoryId
      this.filter.categoryId = categoryId
      const query = Object.assign({}, replaceQuery, this.filter)
      this.$router.replace({
        name: 'sports-tour-list',
        query,
      })
      this.currentcategoryId = categoryId
      this.showmoreLoading = true
      this.tourlistdata = []
      this.fetchSportsTourRouteList({
        categoryId,
        routeType: this.routeType,
        offset: 0,
      }).then((data) => {
        this.isEmpty(data)
      })
      this.showFilterOption = false
      this.selected = {
        time: {},
        city: {},
      }
      this.filter = {
        time: null,
        cityId: null,
      }
      this.getSportsTourFilterInfo(this.filter)
    },
    getSportsTourFilterInfo(filter) {
      const request = {}

      if (filter.cityId) {
        request.cityId = parseInt(filter.cityId, 10)
      }

      if (this.currentcategoryId) {
        request.categoryId = parseInt(this.currentcategoryId, 10)
      }

      if (filter.time) {
        request.time = filter.time
      }
      request.routeType = this.routeType
      this.fetchSportsTourFilterInfo(request)
    },
    onFilterClose() {
      if (this.showFilterOption) {
        this.showFilterOption = false
      }
    },
    handleFilterChanged() {
      this.tourlistdata = []
      this.getSportsTourFilterInfo(this.filter)
      this.showmoreLoading = true
      this.fetchSportsTourRouteList({
        categoryId: this.currentcategoryId,
        opts: this.filter,
        routeType: this.routeType,
        offset: 0,
      }).then((data) => {
        this.isEmpty(data)
      })
    },
    toggleFilterOption(opts, type) {
      if (this.showFilterOption && this.selectedType === type) {
        this.showFilterOption = false
        return
      }
      this.options = opts
      this.showFilterOption = true
      this.selectedType = type
      if (this.selectedType === 'city') {
        this.selectedOption = this.selected.city
        this.optionType = 'multi'
      } else if (this.selectedType === 'time') {
        this.optionType = 'single'
        this.selectedOption = this.selected.time
      }
    },
    handleOptionChanged(option, show) {
      this.filter.categoryId = this.$route.query.categoryId
      this.showFilterOption = show
      this.selectedOption = option
      if (this.selectedType === 'city') {
        this.selected.city = option
        this.filter.cityId = option.id
      } else if (this.selectedType === 'time') {
        this.selected.time = option
        if (option.start) {
          this.filter.time = `${option.start}|${option.end}`
        } else {
          this.filter.time = ''
        }
      }
      this.handleFilterChanged()
    },
    inittoptypeview(type) {
      this.$nextTick(() => {
        if (type === 1 || type === '1') {
          document.getElementById('line1').style.display = 'block'
          document.getElementById('line2').style.display = 'none'
          this.routeType = 1
        } else {
          document.getElementById('line1').style.display = 'none'
          document.getElementById('line2').style.display = 'block'
          this.routeType = 2
        }
      })
    },
    toptype(type) {
      const replaceQuery = {}
      replaceQuery.routeType = this.routeType
      const query = Object.assign({}, replaceQuery, this.filter)
      this.$router.replace({
        name: 'sports-tour-list',
        query,
      })
      this.inittoptypeview(type)
      this.inittabviewdata()
      this.showmoreLoading = true
      this.tourlistdata = []

      // this.fetchSportsTourRouteList(
      //   { categoryId: null, routeType: this.routeType, offset: 0 }).then((data) => {
      //     this.allroutes = data.routes
      //     this.isEmpty(data)
      //     this.showmoreLoading = false
      //     this.showFilterBar = true
      //     this.$route.query.routeType = type
      //     if (this.$route.query.categoryId !== undefined) {
      //       this.$route.query.categoryId = this.$route.query.categoryId
      //     }
      //   })
    },
    inittabviewdata() {
      const request = {}
      request.routeType = this.routeType
      request.categoryId = this.$route.query.categoryId
      this.fetchSportsTourFilterInfo(request).then((data) => {
        this.tabitems = []
        const obj0 = { id: null, value: '全部' }
        this.tabitems.push(obj0)
        for (let i = 0; i < data.categories.length; i += 1) {
          const obj = { id: data.categories[i].id,
            value: data.categories[i].name,
          }
          this.tabitems.push(obj)
        }
        this.$nextTick(() => {
          this.$refs.lineitem[0].style.display = 'block'
          this.$refs.fontitem[0].style.color = '#00C0C1'
          this.$refs.fontitem[0].style.fontWeight = '500'
          for (let i = 1; i < this.$refs.lineitem.length; i += 1) {
            this.$refs.lineitem[i].style.display = 'none'
            this.$refs.fontitem[i].style.color = '#000000'
            this.$refs.fontitem[i].style.fontWeight = 'normal'
          }
          if (this.$route.query.categoryId === undefined) {
            this.switchTab(null)
          } else {
            for (let i = 0; i < this.tabitems.length; i += 1) {
              if (Number(this.$route.query.categoryId) === Number(this.tabitems[i].id)) {
                for (let j = 0; j < this.$refs.lineitem.length; j += 1) {
                  this.$refs.lineitem[j].style.display = 'none'
                  this.$refs.fontitem[j].style.color = '#000000'
                  this.$refs.fontitem[j].style.fontWeight = 'normal'
                }

                this.$refs.sporttabhomeitemref[i].childNodes[0].style.color = '#00C0C1'
                this.$refs.sporttabhomeitemref[i].childNodes[0].style.fontWeight = '500'
                this.$refs.sporttabhomeitemref[i].childNodes[3].style.display = 'block'
                this.switchTab(this.$route.query.categoryId)
                break
              }
            }
          }
        })
      })
    },
    sortBykey(ary, key) {
      return ary.sort((a, b) => {
        const x = a[key]
        const y = b[key]
        if (x < y) {
          return -1
        } else if (x > y) {
          return 1
        }
        return 0
      })
    },
    tabclick(id, event) {
      for (let i = 0; i < this.$refs.lineitem.length; i += 1) {
        this.$refs.lineitem[i].style.display = 'none'
        this.$refs.fontitem[i].style.color = '#000000'
        this.$refs.fontitem[i].style.fontWeight = 'normal'
      }
      event.currentTarget.childNodes[0].style.color = '#00C0C1'
      event.currentTarget.childNodes[0].style.fontWeight = '500'
      event.currentTarget.childNodes[3].style.display = 'block'
      this.currentcategoryId = id
      this.switchTab(id)
    },
    initdata(categoryId, type) {
      this.routeType = type
      this.showmoreLoading = true
      this.tourlistdata = []
      this.inittabviewdata()
    },
  },
  created() {
    if (this.$route.query.routeType === undefined) {
      this.inittoptypeview(1)
      this.initdata(this.$route.query.categoryId, 1)
    } else {
      this.inittoptypeview(this.$route.query.routeType)
      this.initdata(this.$route.query.categoryId, this.$route.query.routeType)
    }
  },
}



// WEBPACK FOOTER //
// ./client/components/SportsTour/SportsTourList.vue